const FTPLinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Batch Ref. No.", field: "batchRef" },
    { headerName: "Charge Period", field: "chargePeriod" },
    { headerName: "RA Number", field: "ranumber" },
    { headerName: "Location Code", field: "locCode" },
    { headerName: "Description", field: "desc" },
    { headerName: "Member Number", field: "memberNumber" },
    { headerName: "Full Points", field: "fullPoints" },
    { headerName: "Half Points", field: "halfPoints" },
    { headerName: "Bonus Points", field: "bonusPoints" },
    { headerName: "Total Cost", field: "totalCost" },
    { headerName: "CCY", field: "ccy" },
    { headerName: "RECH Cost", field: "rechcost" },
    { headerName: "RCY", field: "rcy" },
    { headerName: "Rental Days", field: "rentalDays" },
    { headerName: "CRE Date", field: "credate" },
    { headerName: "Reward Miles Issued", field: "rewardMilesIssued" },
    { headerName: "Promo. Miles Issued", field: "promoMilesIssued" },
    { headerName: "Charge Code", field: "chargeCode" }
];

export default FTPLinesColumns;